export default "__VITE_ASSET__63520fa4__"